var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSleeping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 362"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 770683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5005 24C21.5005 24.5561 21.158 25.0548 20.6389 25.2544L20.539 25.2929C20.1924 25.4262 19.8086 25.4262 19.462 25.2929L19.362 25.2544C18.843 25.0548 18.5005 24.5561 18.5005 24M30.5005 24C30.5005 24.5561 30.158 25.0548 29.6389 25.2544L29.539 25.2929C29.1924 25.4262 28.8086 25.4262 28.462 25.2929L28.362 25.2544C27.843 25.0548 27.5005 24.5561 27.5005 24M24.0693 14.9673C22.2913 15.8624 21.1666 19.8623 24.1768 20.3686C27.1871 20.8749 26.8168 17.4141 25.5944 17.0826M37.5005 25.8397C37.5005 24.9833 37.279 23.0099 35.3938 23.0099C34.2654 18.1343 29.8955 14.5 24.6769 14.5C19.4581 14.5 15.0882 18.1343 13.9598 23.0099C12.1366 23.0099 11.1541 24.5833 11.6124 26.4167C11.9734 27.8608 12.9875 28.7083 14.1941 28.8434C15.6091 33.2838 19.7674 36.5 24.6769 36.5C29.5862 36.5 33.7445 33.2838 35.1595 28.8434C36.8207 28.7083 37.5005 27.0055 37.5005 25.8397Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1246",
    cx: 24.5,
    cy: 30.5,
    rx: 2,
    ry: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 8H35.8857L31.2571 13.3115H36.1429M37.5 15.9672H41L37.4857 20H41",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeping);
export default __webpack_public_path__ + "static/media/sleeping.b137a3117c366a97bb3fd80cb6b1c65c.svg";
export { ForwardRef as ReactComponent };